<template>
  <div >
    <Hero />
    <About />
    <Whywe />
    <Works />
    <Gallery />
    <ThreeD />
    <Submit />
    <News />
  </div>
</template>

<script>
import Hero from '@/components/home/Hero.vue'
import About from '@/components/home/About.vue'
import Whywe from '@/components/home/Whywe.vue'
import Works from '@/components/home/Works.vue'
import Gallery from '@/components/home/Gallery.vue'
import ThreeD from '@/components/home/ThreeD.vue'
import News from '@/components/home/News.vue'
import Submit from '@/components/ui/Submit.vue'

export default {
  components: {Hero, About, Whywe, Works, Gallery, ThreeD, News, Submit}
}
</script>